<template>
  <v-container class="d-flex justify-center">
    <v-card v-if="!success && !error" class="pa-4" width="500">
      <v-card-title class="px-0">Reset Password</v-card-title>
      <v-form v-model="isValid" ref="form">
        <v-text-field
          label="new password"
          type="password"
          v-model="password.newPass"
          :rules="[rules.password_max, rules.password_min, rules.required]"
          @input="validateConfirmation"
        ></v-text-field>
        <v-text-field
          label="confirm new password"
          type="password"
          v-model="password.confirm"
          :rules="[rules.passwordMatches, rules.required]"
        ></v-text-field>
        <v-btn @click="reset_password" :disabled="!isValid" color="accent" class="float-end">Reset</v-btn>
      </v-form>
    </v-card>

    <v-card v-else-if="error" class="pa-4" width="500">
      <v-card-title class="px-0 red--text">ERROR:</v-card-title>
      <v-card-text class="px-0 red--text">{{ error }}</v-card-text>
    </v-card>

    <v-card v-else class="pa-4" width="500">
      <v-card-title class="px-0"> Your password has been successfully changed </v-card-title>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "reset-password.vue",

  data: function () {
    return {
      password: {
        newPass: "",
        confirm: "",
      },

      isValid: false,
      rules: {
        required: (val) => val.length > 0 || "Required",
        passwordMatches: (val) => val === this.password.newPass || "Passwords don't match",
        password_min: (val) => val.length >= 8 || "Password must be 8 chars or more",
        password_max: (val) => val.length <= 128 || "Password too long. Max 128 characters",
      },

      success: false,
      error: "",
    };
  },

  methods: {
    reset_password: function () {
      this.$axios
        .post("/reset-password", {
          user_id: this.$route.params.id,
          new_password: this.password.newPass,
          token: this.$route.params.token,
        })
        .then(() => {
          this.success = true;
        })
        .catch((err) => {
          if (err.response.data.message === "token expired") {
            this.error = "token expired";
          } else if (err.response.data.message === "Invalid token") {
            this.error = "invalid token";
          } else {
            this.error = "An unexpected error occurred";
          }
        });
    },

    validateConfirmation() {
      this.$refs.form.validate();
    },
  },
};
</script>

<style scoped></style>
